import { render, staticRenderFns } from "./Sio.vue?vue&type=template&id=53474cb2&"
import script from "./Sio.vue?vue&type=script&lang=js&"
export * from "./Sio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports